export const ADMIN_TIMEZONE = "America/Edmonton";

export const DEFAULT_DECIBEL_VALUE_SCREENING = 25;
export const DEFAULT_DECIBEL_VALUE_FULL_120 = 10;
export const DEFAULT_DECIBEL_VALUE_ESTERMAN = 10;
export const MIN_DECIBEL_VALUE = 8;
export const MAX_DECIBEL_VALUE = 32;

export const MIN_RX_AXIS_VALUE = 0;
export const MAX_RX_AXIS_VALUE = 180;

// TODO: format enum properties
export const conditionTitles = {
  Glaucoma: "Glaucoma",
  AMD: "AMD",
  DiabeticRetinopathy: "DR",
};

export const DEFAULT_STARTING_ROW_INDEX = 5;
export const visualAcuityRowOptions = [
  "20/200 ft, 6/60 m",
  "20/160 ft, 6/48 m",
  "20/125 ft, 6/38 m",
  "20/100 ft, 6/30 m",
  "20/80 ft, 6/24 m",
  "20/63 ft, 6/18 m",
  "20/50 ft, 6/15 m",
  "20/40 ft, 6/12 m",
  "20/32 ft, 6/9.5 m",
  "20/25 ft, 6/7.5 m",
  "20/20 ft, 6/6 m",
  "20/16 ft, 6/4.8 m",
  "20/12.5 ft, 6/3.8 m",
  "20/10 ft, 6/3 m",
];

export const progressionChartShapes = {
  FAST_THRESHOLD: "circle",
  STANDARD_THRESHOLD: "triangle",
  FULL_THRESHOLD: "square",
};

export const GridTypes = {
  G10: "G_10_2",
  G24: "G_24_2",
  G24C: "G_24_2_C",
  G30: "G_30_2",
  C40: "G_C_40",
  G120: "G_120",
  F120: "FULL_120",
};

export const gridLabels = {
  [GridTypes.G10]: "10-2",
  [GridTypes.G24]: "24-2",
  [GridTypes.G24C]: "24-2C",
  [GridTypes.G30]: "30-2",
  [GridTypes.C40]: "C40",
  [GridTypes.G120]: "120",
};

export const StimulusColors = {
  RED: "Red",
  WHITE: "White",
};

export const StimulusTypes = {
  III: "III",
  IV: "IV",
  V: "V",
};

export const eyeTypes = {
  eyeLeft: "Left",
  eyeRight: "Right",
  eyeBoth: "Both",
};

export const algorithmTypes = {
  SCREEN_FAST: "SCREEN_FAST",
  FAST_THRESHOLD: "FAST_THRESHOLD",
  STANDARD_THRESHOLD: "STANDARD_THRESHOLD",
  FULL_THRESHOLD: "FULL_THRESHOLD",
  ESTERMAN_FAST: "ESTERMAN_FAST",
  FULL_120: "FULL_120",
  PELLI_ROBSON: "PELLI_ROBSON",
  TUMBLING_E: "TUMBLING_E",
  LANDOLT_C: "LANDOLT_C",
  SNELLEN: "SNELLEN",
  BAILEY_LOVIE: "BAILEY_LOVIE",
  BINOCULAR_VISION: "BINOCULAR_VISION",
};

// TODO: Format enum properties and consolidate with the object above
export const fullAlgorithmNames = {
  SCREEN_FAST: "Screen Fast",
  FAST_THRESHOLD: "Fast Threshold",
  STANDARD_THRESHOLD: "Standard Threshold",
  FULL_THRESHOLD: "Full Threshold",
  ESTERMAN_FAST: "Esterman Fast",
  FULL_120: "Full 120",
  PELLI_ROBSON: "Pelli Robson",
  TUMBLING_E: "Tumbling E",
  LANDOLT_C: "Landolt C",
  SNELLEN: "Snellen",
  BAILEY_LOVIE: "Bailey Lovie",
  BINOCULAR_VISION: "Binocular Vision",
};

export const VISUAL_FIELD_TYPE = "VisualField";
export const VISUAL_FIELD_PATH = "visual-field";

// translate the label and translatedType fields when using
export const examCardEnums = {
  VISUAL_FIELD_SCREENING: {
    label: "visual_field_screening",
    type: "VisualField_Screening",
    abbrevType: "VF",
    translatedType: "exams_column_visual_field",
    sectionName: "visualFieldScreeningSections",
    algorithmPath: "visual-field-screening",
  },
  VISUAL_FIELD_THRESHOLDING: {
    label: "visual_field_threshold",
    type: "VisualField_Thresholding",
    abbrevType: "VF",
    translatedType: "exams_column_visual_field",
    sectionName: "visualFieldThresholdingSections",
    algorithmPath: "visual-field-threshold",
  },
  VISUAL_FIELD_FULL_120: {
    label: "single_threshold_title",
    type: "VisualField_Full120",
    abbrevType: "VF",
    translatedType: "exams_column_visual_field",
    sectionName: "visualFieldFull120Sections",
    algorithmPath: "full-120",
  },
  VISUAL_FIELD_ESTERMAN: {
    label: "esterman_report_title",
    type: "VisualField_Esterman",
    abbrevType: "VF",
    translatedType: "exams_column_visual_field",
    sectionName: "visualFieldEstermanSections",
    algorithmPath: "esterman",
  },
  COLOR_VISION: {
    label: "color_vision_title",
    type: "ColorVision",
    abbrevType: "CV",
    translatedType: "color_vision_title",
    sectionName: "colorVisionSections",
    algorithmPath: "color-vision",
  },
  CONTRAST_SENSITIVITY: {
    label: "contrast_sensitivity_title",
    type: "ContrastSensitivity",
    abbrevType: "CS",
    translatedType: "contrast_sensitivity_title",
    sectionName: "contrastSensitivitySections",
    algorithmPath: "contrast-sensitivity",
  },
  VISUAL_ACUITY: {
    label: "visual_acuity_title",
    type: "VisualAcuity",
    abbrevType: "VA",
    translatedType: "visual_acuity_title",
    sectionName: "visualAcuitySections",
    algorithmPath: "visual-acuity",
  },
  SYNOPTOPHORE: {
    label: "synoptophore_title",
    type: "Synoptophore",
    abbrevType: "SY",
    translatedType: "synoptophore_title",
    sectionName: "synoptophoreSections",
    algorithmPath: "synoptophore",
  },
  RAPD: {
    label: "rapd_title",
    type: "RAPD",
    abbrevType: "RAPD",
    translatedType: "rapd_title",
    sectionName: "rapdSections",
    algorithmPath: "rapd",
  },
};

export const positionTypes = {
  near: "Near",
  far: "Far",
  NEAR: "NEAR",
  FAR: "FAR",
};
